import { options } from "./constants/timeline";

export const calcZoomLevel = (startDate: Date, endDate: Date, round = true) => {
  const windowDuration = endDate.getTime() - startDate.getTime();
  const zoomMin = options.zoomMin as number;
  const zoomMax = options.zoomMax as number;
  const zoomLevel = 1 - (windowDuration - zoomMin) / (zoomMax - zoomMin);
  return round ? Number(zoomLevel.toFixed(1)) : zoomLevel;
};
